import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const contactFormDataService = {
  /**
   * Get contact form dropdown data from CMS
   * @returns {Promise} Promise object representing the form data
   */
  async getContactFormData() {
    try {
      const response = await axios.get(`${API_URL}/contact/form-data`, {
        timeout: 10000, // 10 second timeout
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.data && response.data.status === 200) {
        return {
          success: true,
          data: response.data.data,
        };
      } else {
        throw new Error(response.data?.message || 'Failed to fetch contact form data');
      }
    } catch (error) {
      console.error('Error fetching contact form data:', error);
      
      // Return error with details
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Unknown error occurred',
        status: error.response?.status || 500,
      };
    }
  },

  /**
   * Transform API data to match frontend format
   * @param {Object} apiData - Raw API data
   * @returns {Object} Transformed data for frontend use
   */
  transformFormData(apiData) {
    if (!apiData) return { solutions: [], hearUs: [] };

    const solutions = apiData.solutions?.map(item => ({
      value: item.name.toLowerCase().replace(/\s+/g, '-'),
      label: item.name,
      id: item.id
    })) || [];

    const hearUs = apiData.hear_us?.map(item => ({
      value: item.name.toLowerCase().replace(/\s+/g, '-'),
      label: item.name,
      id: item.id
    })) || [];

    return {
      solutions,
      hearUs
    };
  }
};

export default contactFormDataService;